import { useEffect, useState } from "react";

import { Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import AppModal from "./Modal";
import { getCheckoutUrl, getPrices } from "../services/PaymentService";
import yup from "../utils/yup";
import Form from "./form/Form";
import { useSearchParams } from "react-router-dom";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import { logOut } from "../services/AuthService";

const PaymentPlanModal = ({ open, onClose }) => {
  const [prices, setPrices] = useState([]);
  const [formDetails, setFormDetails] = useState(null);
  const [isSuccess, setIsSuccess] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    getPrices().then((data) => setPrices(data));
  }, []);

  useEffect(() => {
    if (searchParams.has("payment_succeeded")) {
      setIsSuccess(searchParams.get("payment_succeeded") === "true");
    }
  }, [searchParams]);

  const paymentFormSchema = yup
    .object()
    .shape({
      price_id: yup
        .string()
        .typeError("The price is not valid.")
        .required("You must choose a plan."),
      promotion_code: yup.string().typeError("The discount code is not valid."),
    })
    .required();

  useEffect(() => {
    setFormDetails({
      submitButtonLabel: "Pay",
      steps: [
        {
          name: "price_id",
          label: "Plan*",
          type: "select",
          options: [
            { label: "Choose a plan...", value: "" },
            ...prices.map((i) => ({
              label: i.title,
              value: i.id,
            })),
          ],
        },
        {
          name: "promotion_code",
          label: "Discount Code",
          type: "text",
        },
      ],
    });
  }, [prices]);

  const form = useForm({
    resolver: yupResolver(paymentFormSchema),
    mode: "onChange",
  });

  const handleSubmit = (values) => {
    getCheckoutUrl(form.setError)(values).then((data) =>
      window.location.replace(data.url)
    );
  };

  const payment = (
    <>
      <p>You must purchase a plan in order to continue using ready.ninja</p>
      {form.formState.isSubmitting ? (
        <div style={{ textAlign: "center" }}>
          <Spinner animation="border" role="status" size="lg" />
          <div>You will be redirected to Stripe...</div>
        </div>
      ) : (
        <Form
          formDetails={formDetails}
          form={form}
          onSubmit={handleSubmit}
          additionalButtons={
            <SecondaryButton className="mt-4 w-100" onClick={logOut}>
              Log Out
            </SecondaryButton>
          }
        />
      )}
    </>
  );

  const successfulPayment = (
    <div style={{ textAlign: "center" }}>
      <h6 style={{ marginBottom: "20px" }}>
        The payment has been <strong>successful</strong>. You can now continue
        using ready.ninja
      </h6>
      <PrimaryButton onClick={onClose}>Close</PrimaryButton>
    </div>
  );

  const errorPayment = (
    <div>
      <p>
        There has been an error with the payment. If the funds have been
        withdrawn from your account, but you still don't have access to the app,
        please contact us at support@ready.ninja.
      </p>
      <div style={{ textAlign: 'center' }}>
          <PrimaryButton onClick={() => setIsSuccess(null)} style={{ width: '30%', height: '25%', fontSize: '16px' }}>Retry payment</PrimaryButton>
      </div>
    </div>
  );

  const renderModalContent = () => {
    if (isSuccess === null) {
        return payment
    }
    return isSuccess ? successfulPayment : errorPayment;
  }

  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={isSuccess === null ? "Purchase a plan" : "Payment Status"}
    >
      {renderModalContent()}
    </AppModal>
  );
};

export default PaymentPlanModal;
